module.exports = __webpack_public_path__ + "static/mushroom_house-e0d452b38afdd426c4218a77173e8eef.jpg";